import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { popModal } from '@/redux/modals/actions';
import { selectAccountSlug, selectBrainId } from '@/redux/session/selectors';
export const useMessageBubble = (brainIdProp?: string) => {
  const navigate = useNavigate();
  const slug = useSelector(selectAccountSlug);
  const brainIdFromRedux = useSelector(selectBrainId);
  const brainId = brainIdProp || brainIdFromRedux;
  const dispatch = useDispatch();

  const onGoToEntity = useCallback(
    (entity: string) => {
      dispatch(popModal());
      navigate(`/${slug}/ai-agents/${brainId}/workflows/entities/${entity}`);
    },
    [dispatch, navigate, slug, brainId]
  );

  return { onGoToEntity };
};
